import FormWithProvider from 'components/forms/form/Form';
import SelectField from 'components/forms/selectField/SelectField';
import {
  AgencySettings,
  CustomIntegrationSettingsType,
  IntegrationEnum,
} from 'models/InternalIntegrationSetting';
import { useTranslation } from 'react-i18next';
import { PinCodeSizeSelectWrapper } from './PinCodeSizeSelect.styles';
import usePinCodeSizeMutation from './usePinCodeSizeMutation';

const PIN_CODE_SIZE_OPTIONS = [
  { value: 4, label: '4' },
  { value: 5, label: '5' },
  { value: 6, label: '6' },
  { value: 7, label: '7' },
  { value: 8, label: '8' },
];

const PinCodeSizeSelect = ({
  enumId,
  customIntegrationSettings,
}: {
  enumId: IntegrationEnum;
  customIntegrationSettings: AgencySettings['customIntegrationSettings'];
}) => {
  const { t } = useTranslation();
  const { mutate: updatePinCodeSize, isLoading } = usePinCodeSizeMutation();

  const getInitialPinCodeSize = () => {
    if (
      customIntegrationSettings?.type ===
      CustomIntegrationSettingsType.REMOTELOCK
    ) {
      return customIntegrationSettings?.pincodeLength;
    }

    return PIN_CODE_SIZE_OPTIONS[0].value;
  };

  if (!customIntegrationSettings) {
    return null;
  }

  return (
    <PinCodeSizeSelectWrapper>
      <FormWithProvider
        defaultValues={{ pinCodeSize: getInitialPinCodeSize() }}
        // the request dispatch is handled by the onChangeHandler, since we don't have a submit button
        onSubmit={() => {}}
      >
        <SelectField
          name="pinCodeSize"
          label={t('pageIntegrations.integrationDetails.pinCodeSize')}
          options={PIN_CODE_SIZE_OPTIONS}
          colSmInput={4}
          colSmLabel={8}
          data-testid="pin-code-size-select"
          disabled={isLoading}
          onChangeHandler={(e) => {
            const { value } = e.target as HTMLSelectElement;

            updatePinCodeSize({
              enumId,
              pinCodeSize: Number(value),
            });
          }}
        />
      </FormWithProvider>
    </PinCodeSizeSelectWrapper>
  );
};

export default PinCodeSizeSelect;
